import { createClient } from '@supabase/supabase-js';

// These will be replaced with your actual Supabase URL and anon key
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Check .env file.');
}

// Create a single supabase client for the entire app
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Example function to test the connection
export const testSupabaseConnection = async () => {
  try {
    // First, log the URL being used (with masked key for security)
    console.log(`Testing connection to Supabase at URL: ${supabaseUrl}`);
    console.log(`Using anon key: ${supabaseAnonKey ? '✅ Key provided (masked for security)' : '❌ Missing key'}`);
    
    // Attempt a simple query to verify connection
    const { data, error } = await supabase.from('test').select('*').limit(1);
    
    if (error) {
      console.error('Supabase connection test failed:', error);
      return { 
        success: false, 
        error: error,
        message: `Error: ${error.message}. Code: ${error.code}. Hint: ${error.hint || 'No hint provided'}`
      };
    }
    
    // Connection successful
    console.log('Supabase connection successful!');
    console.log('Data returned:', data);
    
    return { 
      success: true, 
      data,
      message: 'Connection successful. Your Supabase instance is properly configured.'
    };
  } catch (err) {
    console.error('Error testing Supabase connection:', err);
    return { 
      success: false, 
      error: err,
      message: err instanceof Error ? err.message : 'Unknown error occurred'
    };
  }
}; 